"use strict";
exports.__esModule = true;
exports.isValidAddress = exports.getCroSdk = exports.isTestNet = exports.TestnetCroeseid4 = exports.FIXED_DEFAULT_GAS_LIMIT = exports.FIXED_GAS_PRICE = exports.TESTNET_CURRENCY_ID = void 0;
var chain_jslib_1 = require("@crypto-com/chain-jslib");
exports.TESTNET_CURRENCY_ID = "crypto_org_croeseid";
exports.FIXED_GAS_PRICE = 0.025;
exports.FIXED_DEFAULT_GAS_LIMIT = 200000;
exports.TestnetCroeseid4 = {
    defaultNodeUrl: "https://testnet-croeseid-4.crypto.org",
    chainId: "testnet-croeseid-4",
    addressPrefix: "tcro",
    validatorAddressPrefix: "tcrocncl",
    validatorPubKeyPrefix: "tcrocnclconspub",
    coin: {
        baseDenom: "basetcro",
        croDenom: "tcro"
    },
    bip44Path: {
        coinType: 1,
        account: 0
    },
    rpcUrl: "https://testnet-croeseid-4.crypto.org:26657"
};
var croSdks = {};
/**
 * Returns true if we are using testnet
 *
 * @param {string} currency
 */
function isTestNet(currencyId) {
    return currencyId == exports.TESTNET_CURRENCY_ID;
}
exports.isTestNet = isTestNet;
/**
 * Get CroSdk
 * @param {string} currency
 */
function getCroSdk(currencyId) {
    if (!croSdks[currencyId]) {
        croSdks[currencyId] = isTestNet(currencyId)
            ? (0, chain_jslib_1.CroSDK)({
                network: exports.TestnetCroeseid4
            })
            : (0, chain_jslib_1.CroSDK)({
                network: chain_jslib_1.CroNetwork.Mainnet
            });
    }
    return croSdks[currencyId];
}
exports.getCroSdk = getCroSdk;
/**
 * Returns true if address is a valid md5
 *
 * @param {string} address
 * @param {boolean} useTestNet
 */
var isValidAddress = function (address, currencyId) {
    if (!address)
        return false;
    var network = isTestNet(currencyId) ? exports.TestnetCroeseid4 : chain_jslib_1.CroNetwork.Mainnet;
    var addressProps = {
        address: address,
        network: network,
        type: chain_jslib_1.utils.AddressType.USER
    };
    var addressValidator = new chain_jslib_1.utils.AddressValidator(addressProps);
    return addressValidator.isValid();
};
exports.isValidAddress = isValidAddress;
//# sourceMappingURL=logic.js.map